export type PendingImageStatus = 'draft' | 'uploading' | 'failed';
export type PendingCropMode = 'fixed' | 'freeform';

export interface CropAreaPixels {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface PendingImageDimensions {
  width: number;
  height: number;
}

export interface PendingImageAdjustments {
  brightness: number;
  contrast: number;
  warmth: number;
}

export const DEFAULT_PENDING_IMAGE_ADJUSTMENTS: PendingImageAdjustments = {
  brightness: 0,
  contrast: 0,
  warmth: 0,
};

export interface PendingImageItem {
  localId: string;
  file: File;
  filename: string;
  objectUrl: string;
  description: string;
  zoom: number;
  cropMode: PendingCropMode;
  fixedAspectRatio: number;
  croppedAreaPixels: CropAreaPixels;
  dimensions: PendingImageDimensions;
  adjustments: PendingImageAdjustments;
  status: PendingImageStatus;
  errorMessage?: string;
}
